import { Container, Row, Col, Spinner } from "reactstrap";

const Loading = () => {
    return (
        <div
            // className="d-flex flex-column justify-content-center align-items-center min-vh-100 min-vw-100"
            style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Spinner 
                color="primary"
                style={{ width: '3rem', height: '3rem'}}
            />
            <br />
            <span>Loading...</span>
        </div>
    )
};

export default Loading;